export const mapFormResultValueToString = (value: unknown): string => {
  if (value === null || value === undefined) {
    return ''
  }

  if (typeof value === 'boolean') {
    return value ? 'Yes' : 'No'
  }

  if (Array.isArray(value)) {
    return value.map(mapFormResultValueToString).join(', ')
  }

  if (typeof value === 'object') {
    return Object.entries(value)
      .map(([key, innerValue]) => `${key}: ${mapFormResultValueToString(innerValue)}`)
      .join(', ')
  }

  return String(value)
}

export const escapeFormResultCsvValue = (value: string): string => {
  if (value.includes(',') || value.includes('\n')) {
    return `"${value}"`
  }

  if (value.includes('"')) {
    return `"${value.replace(/"/g, '""')}"`
  }

  return value
}
